import React, { ReactNode } from "react";

import { SupAlert, SupCheckCircle, SupFlag, SupInfoCircle, SupNotifications } from "@repo/core-ui";
import { SupToast, toast } from "@repo/core-ui";

export function notifyMessage(
  title?: string,
  content?: string,
  color: "primary" | "info" | "error" | "warning" | "success" = "primary",
  toastIcon: ReactNode = undefined,
  toastId: string | undefined = undefined,
  toastDuration: number = 2000,
  actions: ReactNode = undefined
) {
  if (toastIcon === undefined) {
    switch (color) {
      case "primary":
        toastIcon = <SupNotifications />;
        break;
      case "info":
        toastIcon = <SupInfoCircle />;
        break;
      case "error":
        toastIcon = <SupAlert />;
        break;
      case "warning":
        toastIcon = <SupFlag />;
        break;
      case "success":
        toastIcon = <SupCheckCircle />;
        break;
    }
  }

  toast.custom(
    // @ts-ignore
    t => (
      <SupToast
        className={"max-w-max"}
        color={color}
        icon={toastIcon}
        title={title}
        content={content}
        actions={actions}
        onClose={() => {
          toast.remove(t.id);
        }}
      />
    ),
    {
      id: toastId ? toastId : `${title}-${content}`,
      duration: toastDuration === 0 ? 1000 * 60 * 60 * 24 : toastDuration,
    }
  );
}
